













































import { Component, Mixins } from "vue-property-decorator";

// Mixins
import PaymentStatusMixin from "@/mixins/paymentStatusMixin";

@Component({
  components: {
    "invoice-provider": () =>
      import("@/components/app/global/invoices/invoiceProvider.vue"),
    "invoice-payment-method-msg": () =>
      import("@/components/app/global/invoices/invoicePaymentMethodMsg.vue"),
    "invoice-details": () =>
      import("@/components/app/global/invoices/invoiceDetails.vue"),
    "invoice-pending-payment-msg": () =>
      import("@/components/app/global/invoices/invoicePendingPaymentMsg.vue"),
    "invoice-status-msg": () =>
      import("@/components/app/global/invoices/invoiceStatusMsg.vue"),
    "invoice-payments-list": () =>
      import("@/components/app/global/payments/invoicePaymentsList.vue"),
    "delegated-object-msg": () =>
      import("@/components/app/global/delegates/delegatedObjectMsg.vue")
  }
})
export default class AdminUpmindInvoiceView extends Mixins(PaymentStatusMixin) {
  public invoiceId = this.$route.params.invoiceId;

  // Methods

  public async refreshUpmindUser() {
    window.location.reload();
  }
}
